export { stylesFactory } from '@orthly/ui-primitives';
